import { createRoute } from '@tanstack/react-router';

import { WelcomeDashboard } from '$/pages/DashboardPages/pages/Welcome';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { STANDARD_STALE_TIME } from '$/services/constants';
import { useProjectStore } from '$/stores/useProjectStore';

export const DashboardRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/',
  component: WelcomeDashboard,
  onEnter: async () => {
    await useProjectStore.getState().refetchProjects();
  },
  staleTime: STANDARD_STALE_TIME,
});
